import type { App } from 'vue'
import { Button } from './Button'
import { Input, Layout, Spin } from 'ant-design-vue'
import { h } from 'vue'

export function registerGlobComp(app: App) {
  Spin.setDefaultIndicator({
    indicator: h('img', {
      src: '/@/assets/images/loading.png',
      class: 'animate-spin !w-[48px] !h-[48px]',
    }),
  })
  app.use(Input).use(Button).use(Layout).use(Spin)
}
